import React, { useEffect, useState } from "react";
import UsersTable from "./table";
import api from "../../services/api";
import { useInput } from "../../hooks/useInput";
import Breadcrumbs from "../../components/breacrumbs";
import BackButton from "../../components/backButton";
import { TableSkeleton, SearchSkeleton } from "../../components/skeleton";
import { useAuth } from "../../context/AuthContext";
import NewMemberModal from "./NewMemberModal";

export default function InnerPage() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewMemberModal, setShowNewMemberModal] = useState(false);
  const { value: name, bind: bindName } = useInput("");
  const { user } = useAuth();
  const isAdmin = user?.admin === 1;

  const fetchMembers = () => {
    setLoading(true);
    const minLoadingTime = new Promise(resolve => setTimeout(resolve, 800));
    const fetchData = api.get("/api/members");
    Promise.all([fetchData, minLoadingTime])
      .then(([response]) => {
        setData(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Erro ao buscar membros:", err);
        setTimeout(() => setLoading(false), 800);
      });
  };

  useEffect(() => {
    fetchMembers();
  }, []);

  return (
    <>
      <div className="container d-flex align-items-center justify-content-between mt-3 mb-1">
        <BackButton toFallback="/home" />
        <Breadcrumbs />
      </div>
      
      <div className="members-title-minimal">
        <h2>MEMBROS</h2>
        <p className="members-count">{loading ? 'Carregando...' : `${data.length} registrados`}</p>
      </div>
      <div className="container">
        <div className="col">
          {loading ? (
            <>
              <SearchSkeleton />
              <TableSkeleton rows={10} columns={7} />
            </>
          ) : (
            <>
              <div className="mb-3 d-flex gap-2 align-items-center">
                <input
                  type="text"
                  className="form-control"
                  style={{ textAlign: "center" }}
                  placeholder="Procure aqui por nome, apelido ou qualquer outro dado"
                  {...bindName}
                />
                {isAdmin && (
                  <button
                    className="btn btn-primary text-nowrap"
                    onClick={() => setShowNewMemberModal(true)}
                  >
                    + Novo Membro
                  </button>
                )}
              </div>
              <UsersTable id="users" data={data} search={name} isAdmin={isAdmin} onMemberDeleted={fetchMembers} />
            </>
          )}
        </div>
      </div>

      <NewMemberModal
        open={showNewMemberModal}
        onClose={() => setShowNewMemberModal(false)}
        onSuccess={fetchMembers}
      />
    </>
  );
}
